/* eslint no-underscore-dangle: 0 */

import deepmerge from 'deepmerge';
import { get } from 'lodash/fp';
import { parse as parseQuery } from 'qs';
import _ from 'lodash';

import baseBuildConfig from '../config/build.json';
import baseConfig from '../config/app.json';
import nativeiOSConfig from '../config/nativeApp/ios';
import nativeAndroidConfig from '../config/nativeApp/android';
import draftstarsConfig from '../config/brands/draftstars';
import playupConfig from '../config/brands/playup';
import indiaConfig from '../config/brands/india';

import draftstarsLocale from '../config/locale/au-draftstars.json';

const getCustomConfigHardWay = () => {
  const mergeObjects = (...objects) => {
    return deepmerge.all(objects, {
      arrayMerge: (a, b) => b // second array overrides first
    });
  };

  const getBrandConfig = id => {
    try {
      switch (id) {
        case 'draftstars':
          return draftstarsConfig;
        case 'playup':
          return playupConfig;
        case 'india':
          return indiaConfig;
        default:
          return {};
      }
    } catch (error) {
      console.warn(`No config exists for brand "${id}".`, error);
    }
    return {};
  };

  // const getLocaleConfig = id => {
  //   try {
  //     return draftstarsLocale;
  //   } catch (error) {
  //     console.warn(`No config exists for locale "${id}".`, error);
  //   }
  //   return {};
  // };

  const brandConfig = getBrandConfig(process.env.APP_BRAND);

  const app = mergeObjects(
    _.get(brandConfig.app, 'default'),
    _.get(brandConfig.app, process.env.APP_ENV || 'development')
  );

  const build = mergeObjects(baseBuildConfig, brandConfig.build);
  // const localeConfig = getLocaleConfig(app.settings.locale || 'au');

  return {
    app: Object.assign({}, app, {
      locale: draftstarsLocale
    }),
    build
  };
};

function getDevConfig() {
  if (process.env.NODE_ENV !== 'development') return {};

  let appBrand = process.env.APP_BRAND;
  if (window.localStorage) {
    const devAppBrand = window.localStorage.getItem('appBrand');
    if (devAppBrand) appBrand = devAppBrand;
  }
  switch (appBrand) {
    case 'draftstars':
      return draftstarsConfig.app.default;
    case 'playup':
      return playupConfig.app.default;
    case 'india':
      return indiaConfig.app.default;
    default:
      return {};
  }
}

function getNativeConfig(nativeApp) {
  switch (nativeApp) {
    case 'ios':
      return nativeiOSConfig;
    case 'android':
      return nativeAndroidConfig;
    default:
      return {};
  }
}
// const customConfig = typeof window !== 'undefined' ? window.__CONFIG__ : undefined;
const customConfig = getCustomConfigHardWay(); // window.__CONFIG__ is loaded from webpack and will not be available on portal, so move it to here

const query = parseQuery(get('location.search', window), { ignoreQueryPrefix: true });
const nativeConfig = getNativeConfig(query['native-app']);
const devConfig = getDevConfig();
const fullConfig = customConfig.app
  ? deepmerge.all([baseConfig, customConfig.app, nativeConfig, devConfig], {
      arrayMerge: (a, b) => b // always overwrite base array with custom array
    })
  : baseConfig;

export default fullConfig;
